import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: 'fc964a66-16c7-45d9-9e23-c46013fe0658',
	[AppLanguageCodes.SK]: 'fc964a66-16c7-45d9-9e23-c46013fe0658',
	[AppLanguageCodes.DE]: 'fc964a66-16c7-45d9-9e23-c46013fe0658',
}


export const TextBoxProbe = () => {

	return (
		<MdxDiv className='text-box' articleIds={articleIds}>
		</MdxDiv>
	);
};